import { render, staticRenderFns } from "./newBuild.vue?vue&type=template&id=0bc09872"
import script from "./newBuild.vue?vue&type=script&lang=ts"
export * from "./newBuild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports